import VoucherRoutes from "./Voucher";
import ReportRoute from "./Reports/Routes";
import SettingsRoute from "./Settings/Routes";
import ItemRoute from "./Inventory/Item/Routes";
import RemoteItem from "./Inventory/RemoteItem/Routes";
import GroupRoute from "./Inventory/Group/Routes";
import RemoteGroup from "./Inventory/RemoteGroup/Routes";
import AccountGroupRoute from "./Account/Group/Routes";
import AccountLedgerRoute from "./Account/Ledger/Routes";
import NoteSheet from "./Account/NoteSheet/Routes";
import AccountCostCenterRoute from "./Account/CostCenter/Routes";
import RemoteLedger from "./Account/RemoteLedger/Routes";
import PreSanction from "./Account/PreSanction/Routes";
import ProductGroup from "./Inventory/ProductGroup/Routes";

export default [
    ...VoucherRoutes,
    ...AccountGroupRoute,
    ...AccountLedgerRoute,
    ...RemoteLedger,
    ...AccountCostCenterRoute,
    ...ItemRoute,
    ...RemoteItem,
    ...GroupRoute,
    ...RemoteGroup,
    ...ReportRoute,
    ...SettingsRoute,
    ...ProductGroup,
    ...NoteSheet,
    ...PreSanction,
];
